import { Link } from "react-router-dom";
import HeroSlideshow from "./HeroSlideshow";

const HeroSection = () => {
  return (
    <section className="bg-gradient-to-br from-white via-blue-50 to-blue-100 relative overflow-hidden overflow-x-hidden max-w-full">
      <div className="max-w-7xl mx-auto sm:px-6 lg:px-8 py-8 flex flex-col-reverse md:flex-row items-center justify-between gap-10 sm:gap-14 lg:gap-20">
        {/* Left: Text Content */}
        <div className="w-full md:w-1/2 flex flex-col justify-center items-center md:items-start text-center md:text-left space-y-6 px-4 sm:px-6 lg:px-4">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold text-primary leading-tight tracking-tight">
            Designing Impact That Lasts
          </h1>

          <p className="text-base sm:text-lg text-gray-700 max-w-xl font-body">
  Our belief is simple:{" "}
  <span className="font-semibold text-secondary">
    systemic change happens when diverse actors work together with shared purpose
  </span>.
</p>


          <div className="flex flex-col sm:flex-row justify-center md:justify-start gap-4">
            <Link
              to="/initiatives"
              className="px-6 py-3 bg-primary text-white font-semibold rounded-full hover:bg-primary/90 transition shadow-md"
            >
              Explore Our Work
            </Link>
          </div>
        </div>

        {/* Right: Hero Image */}
        <div className="w-full md:w-1/2 flex justify-center">
          <div className="w-72 sm:w-80 md:w-full max-w-full h-[280px] sm:h-[360px] md:h-[480px] lg:h-[560px] relative">
            <HeroSlideshow />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
